import { Setting, SettingEditFormValues } from "./types";

/*---------------------------------------------------------------------------------------
  SETTING SEARCH
-----------------------------------------------------------------------------------------*/

export const transformSetting = (res: any): Setting => {
  return {
    id: res.id,
    rtvFee: res.rtvFee,
    fireExtinguisher: res.fireExtinguisher,
    mandatoryEquipment: res.mandatoryEquipment,
    offerSaleFormatNumber: res.offerSaleFormatNumber,
    offerSaleDurationDays: res.offerSaleDurationDays,
    offerSaleNoteDefault: res.offerSaleNoteDefault,
    contractSaleFormatNumber: res.contractSaleFormatNumber,
    contractSaleDeliveryTime: res.contractSaleDeliveryTime,
    contractSalePlaceOfVehicleDelivery: res.contractSalePlaceOfVehicleDelivery,
    invoiceFormatNumber: res.invoiceFormatNumber,
    invoicePaymentIBAN: res.invoicePaymentIBAN,
    tenantOib: res.tenantOib,
    inVatSystem: res.inVatSystem ?? true,
    businessUnitMark: res.businessUnitMark,
    cashRegisterMark: res.cashRegisterMark,
    operaterOib: res.operaterOib,
    fiscalizationDemoMode: res.fiscalizationDemoMode ?? true,
  };
};

/*---------------------------------------------------------------------------------------
    SETTING UPDATE
-----------------------------------------------------------------------------------------*/

export const transformSettingOnUpdate = (
  formValues: SettingEditFormValues
): any => ({
  id: formValues.id,
  rtvFee: formValues.rtvFee,
  fireExtinguisher: formValues.fireExtinguisher,
  mandatoryEquipment: formValues.mandatoryEquipment,
  offerSaleFormatNumber: formValues.offerSaleFormatNumber,
  offerSaleDurationDays: formValues.offerSaleDurationDays,
  offerSaleNoteDefault: formValues.offerSaleNoteDefault,
  contractSaleFormatNumber: formValues.contractSaleFormatNumber,
  contractSaleDeliveryTime: formValues.contractSaleDeliveryTime,
  contractSalePlaceOfVehicleDelivery: formValues.contractSalePlaceOfVehicleDelivery,
  invoiceFormatNumber: formValues.invoiceFormatNumber,
  invoicePaymentIBAN: formValues.invoicePaymentIBAN,
  tenantOib: formValues.tenantOib,
  inVatSystem: formValues.inVatSystem,
  businessUnitMark: formValues.businessUnitMark,
  cashRegisterMark: formValues.cashRegisterMark,
  operaterOib: formValues.operaterOib,
  fiscalizationDemoMode: formValues.fiscalizationDemoMode,
});
